;(function () {
	const mobileViewXP = 750
	const mySwipersTLG = {}
	const mobileLayoutTypes = {
		slider: 'slider',
		grid: 'grid',
	}

	const destroySlider = (slider) => {
		const sectionId = slider.dataset.id
		const slides = slider.querySelectorAll('.products-slider__swiper')
		const swiperWrapper = slider.querySelector(
			'.products-slider__swiper-wrapper'
		)
		const pagination = slider.querySelector('.products-slider-pagination')

		if (slider?.swiper) slider.swiper.destroy()

		if (pagination && !pagination?.classList?.contains('hide-pagination')) {
			pagination?.classList?.add('hide-pagination')
		}

		if (swiperWrapper && !swiperWrapper?.classList?.contains('products-grid')) {
			swiperWrapper?.classList?.add('products-grid')
			swiperWrapper?.classList?.remove('swiper-wrapper')
		}

		slides.forEach((slide) => {
			slide.removeAttribute('style')
			slide.classList.remove('swiper')
			slide
				.querySelectorAll('.products-slider__slide')
				.forEach((element) => element.classList.remove('swiper-slide'))
		})

		if (mySwipersTLG[sectionId] && mySwipersTLG[sectionId] != null) {
			slider.classList?.add('destroyed')
			mySwipersTLG[sectionId].destroy(true, true)
			mySwipersTLG[sectionId] = null
		}
	}

	const updateSliderClasses = (slider) => {
		const pagination = slider.querySelector('.products-slider-pagination')
		const mySwiper  = slider.querySelector('.mySwiper ')
		const swiperWrapper = slider.querySelector(
			'.products-slider__swiper-wrapper'
		)

		if (
			swiperWrapper &&
			!swiperWrapper?.classList?.contains('swiper-wrapper')
		) {
			swiperWrapper?.classList?.add('swiper-wrapper')
			swiperWrapper?.classList?.remove('products-grid')
			mySwiper.classList.add('swiper')
			swiperWrapper
				.querySelectorAll('.products-slider__slide')
				.forEach((element) => element.classList.add('swiper-slide'))
		}

		if (pagination && pagination?.classList?.contains('hide-pagination')) {
			pagination?.classList?.remove('hide-pagination')
		}
	}

	const initSlider = (slider) => {
		if (
			slider.classList.contains('destroyed') ||
			(!slider.classList.contains('destroyed') &&
				!slider.classList.contains('slider_started'))
		) {
			slider?.classList?.remove('destroyed')
			updateSliderClasses(slider)
		} else if (slider.classList.contains('slider_started')) {
			return ''
		}

		slider.classList.add('slider_started')

		const sectionId = slider.dataset.id
		const perRow = parseInt(slider.dataset.perRow) || 4
		const rows = parseInt(slider.dataset.rows) || 1
		const mobile = parseInt(slider.dataset.mobile) || 1
		const speed = slider.dataset.speed * 1000
		const delay = slider.dataset.delay * 1000
		const autoplay = toBoolean(slider.dataset.autoplay)
		const stopAutoplay = toBoolean(slider.dataset.stopAutoplay)
		const showArrows = toBoolean(slider.dataset.showArrows)
		
		let autoplayParm = {}
		let arrowsParm = {}
		
		if (autoplay) {
			autoplayParm = {
				autoplay: {
					delay: delay,
					pauseOnMouseEnter: stopAutoplay,
					disableOnInteraction: false,
				},
			}
		}
		
		if (showArrows) {
			arrowsParm = {
				navigation: {
					nextEl: `#${sectionId} .swiper-button-next`,
					prevEl: `#${sectionId} .swiper-button-prev`,
				},
				pagination: {
					el: `#${sectionId} .products-slider-pagination`,
					clickable: true,
				},
			}
		}
		
		let swiperParms = {
			speed: speed,
			keyboard: true,
			slidesPerView: mobile,
			slidesPerGroup: mobile,
			spaceBetween: 16,
			breakpoints: {
				576: {
					slidesPerView: perRow >= 2 ? 2 : 1,
					slidesPerGroup: perRow >= 2 ? 2 : 1,
				},
				750: {
					slidesPerView: perRow >= 3 ? 3 : perRow,
					slidesPerGroup: perRow >= 3 ? 3 : perRow,
					...(rows > 1 ? {
						grid: {
							rows: rows,
							fill: 'row'
						},
						slidesPerGroup: perRow
					} : {})
				},
				990: {
					slidesPerView: perRow >= 4 ? 4 : perRow,
					slidesPerGroup: perRow >= 4 ? 4 : perRow,
					...(rows > 1 ? {
						grid: {
							rows: rows,
							fill: 'row'
						},
						slidesPerGroup: perRow
					} : {})
				},
				1150: {
					spaceBetween: 16,
					slidesPerView: perRow,
					slidesPerGroup: perRow,
					...(rows > 1 ? {
						grid: {
							rows: rows,
							fill: 'row'
						},
						slidesPerGroup: perRow
					} : {})
				},
			},
			...arrowsParm,
			...autoplayParm,
		}

		mySwipersTLG[sectionId] = new Swiper(`#${sectionId} .swiper`, swiperParms)
	}

	const productSliderTLG = () => {
		const productSliders = Array.from(
			document.querySelectorAll('.products-slider-tlg')
		)

		if (productSliders.length === 0) return
		productSliders.forEach((slider) => {
			const sectionResizeObserver = new ResizeObserver((entries) => {
				entries.forEach((entry) => {
					const mobileLayoutType = entry.target.dataset.mobileLayoutType

					if (
						entry.contentRect.width < mobileViewXP &&
						mobileLayoutType === mobileLayoutTypes.grid
					) {
						destroySlider(entry.target)
					} else {
						initSlider(entry.target)
					}
				})
			})

			sectionResizeObserver.observe(slider)
		})
	}

	function toBoolean(string) {
		return string === 'true' ? true : false
	}

	if (document.querySelector('product-recommendations') !== null) {
		const initslider = setInterval(() => {
			if (
				document
					.querySelector('product-recommendations')
					.querySelector('.swiper') !== null
			) {
				if (
					document
						.querySelector('product-recommendations')
						.querySelector('.swiper')
						.classList.contains('swiper-initialized')
				) {
					clearInterval(initslider)
				}
				productSliderTLG()
			}
		}, 100)
	}

	document.addEventListener('DOMContentLoaded', function () {
		productSliderTLG()
		document.addEventListener('shopify:section:load', function (event) {
			productSliderTLG()
		})
	})
})()